import router from "@/router"
export const useRoutingToVue = () => {
    function routerGoTo({ name, params, query }) {
        router.push({
            name: name,
            params: params,
            query: query,
        })
    }

    function routerGoBack() {
        router.go(-1)
    }

    return {
        routerGoTo,
        routerGoBack,
    }
}
